import { Component } from 'react';

export interface ErrorProps {
    children: React.ReactNode;
    //todo: add error properties, if any
}

export interface ErrorState {
    error: boolean;
    message: string;
    errInfo: any;
    stack: any;
    Error: any;
}

export default class ErrorBoundary extends Component<ErrorProps, ErrorState> {
    constructor(props: ErrorProps) {
        super(props);
        this.state = {
            error: false,
            message: '',
            Error: null,
            stack: null,
            errInfo: null
        };
    }
    componentDidCatch(err: any, errInfo: any) {
       console.log({err, errInfo})
        this.setState({
            error: true,
            errInfo,
            Error: err?.message,
            stack: err?.stack,
            message: errInfo.componentStack
        });
    }

    render() {
        if (this.state.error) {
            return (
                <div className="container">
                    <div className="row">
                        <h1>Error</h1>
                        <p>Something went wrong please contact your administrator</p>
                        <p>{JSON.stringify(this.state.Error)}</p>
                        <p>{JSON.stringify(this.state.stack)}</p>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}
